import Documentation from 'components/Documentation/Documentation.component';

const DocumentationPage = () => {
	return <Documentation />;
};

export default DocumentationPage;
